module.exports = {
  title: '功能授权',
  route: {
    path: '/merchant-manage',
    children: {
      path: 'function-authorize',
    },
  },
};
